import { MonitorStarIcon } from './MonitorStarIcon';

/**
 * author: Austin Andrews
 * id 6E372D46-ECFB-4275-B058-036C89A3413B
 * name monitor-star
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/monitor-star.svg
 * tags
 * - Device / Tech 
 */
export const MonitorFavoriteIcon = MonitorStarIcon;
export default MonitorFavoriteIcon